module.exports = __webpack_public_path__ + "img/Learn anywhere.2acc8b53.svg";